module.exports = __webpack_public_path__ + "static/media/finance.d9150ea6.png";